
import React, { useEffect, useState } from 'react'

import CourseACourseHorizontal from '../../Components/SingleCommandeHorizontal/CourseACourseHorizontal'
import MiseADispoHorizontal from '../../Components/SingleMiseADispoHorizontalForChauffeur/MiseADispoHorizontal'

import { GradientText, SubText } from '../PasserCommande/PasserCommande.styles'
import LayoutChauffeur from '../../Components/LayoutChauffeur/LayoutChauffeur'
import { getCommandesByChauffeurForHistorique, getCommandeHistoriqueByCityForChauffeur, getCommandeHistoriqueByIdForChauffeur, getCommandeHistoriqueByDateForChauffeur } from '../../api/commande'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import AutocompleteAddress from '../../Components/GooglePlacesAutoComplete/AutocompleteAddress'
import UltimatePaginationBasic from '../../Components/Pagination/Pagination'
import Select from 'react-select'
import moment from 'moment'
import toast from 'react-hot-toast'
import DetailCommandeModal from '../../Components/DetailCommande/DetailCommandeChauffeurModal'
import { useTranslation } from 'react-i18next'

const SIZE = 10
function HistoriqueChauffeur() {
	const history = useHistory()
	const [commandes, setCommandes] = useState([])
	const token = useSelector((state) => state.auth.token);
	const user = useSelector((state) => state.auth.user)
	const [searchCriteria, setSearchCriteria] = useState('id')
	const [adresseValue, setAdresseValue] = useState('');
	const [searchQueryId, setSearchQueryId] = useState('')
	const [selectedDate, setSelectedDate] = useState(null);
	const [total, setTotal] = useState(1)
	const [page, setPage] = useState(1)
	const [isSearching, setIsSearching] = useState(false)
	const [chargementEnCours, setChargementEnCours] = useState(false)
	const {t} = useTranslation()
	const [selectedOption, setSelectedOption] = useState({
		value: 'id', label: t("search_by_id")
	});
	const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)
	const [selectedCommande, setSelectedCommande] = useState(null)
	const handleChange = (selectedOption) => {
		setSelectedOption(selectedOption);
		setSearchCriteria(selectedOption.value)
	}

	const fetchCommandes = async (page) => {
		setChargementEnCours(true);
		try {
			let res;
			if (isSearching) {
				if (searchCriteria === 'id') {
					res = await getCommandeHistoriqueByIdForChauffeur(user._id, searchQueryId, token)
				} else
					if (searchCriteria === 'city') {
						res = await getCommandeHistoriqueByCityForChauffeur(user._id, adresseValue.label, token, page, SIZE)
					} else if (searchCriteria === 'date') {
						const date = moment(selectedDate).format();
						res = await getCommandeHistoriqueByDateForChauffeur(user._id, date, token, page, SIZE)
					}
			} else {
				res = await getCommandesByChauffeurForHistorique(user._id, token, page, SIZE)
			}
			setCommandes(res.commandes.docs);
			setTotal(res.totalPages);
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			setChargementEnCours(false);
		}
	};
	const resetData = async () => {
		setIsSearching(false);
		setSearchQueryId('');
		setSearchCriteria("id")
		setSelectedOption({
			value: 'id', label: t("search_by_id")
		})
		setPage(1);
	};


	const handleSearch = () => {
		setIsSearching(true);
		setPage(1);
		if (isSearching) {
			fetchCommandes(1);

		}
	};


	useEffect(() => {
		fetchCommandes(page)
	}, [page, isSearching])

	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth <= 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth <= 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<LayoutChauffeur>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}
			>
				<GradientText style={{
					fontSize: isSmallScreen ? '2rem' : '2.5rem'
				}}>{t("history").toUpperCase()}</GradientText>
				<SubText>
					{t("history_subtext")}
				</SubText>

				<div
					style={{
						width: '100%',
						fontFamily: 'Montserrat',
						minHeight: '60vh',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
						marginTop: '1rem',
					}}
				>
					<div
						style={{
							width: '100%',
							fontFamily: 'Montserrat',
							marginBottom: '2rem',
							marginTop: '1rem',
							display: 'flex',
							flexDirection: 'row',
							flexDirection: isSmallScreen ? 'column' : 'row',
							gap: isSmallScreen ? '10px' : '0'
						}}

					>
						<div
							style={{
								width: isSmallScreen ? '100%' : '350px',
								fontFamily: 'Montserrat',
								marginRight: isSmallScreen ? 0 : '1rem',
							}}
						>
							<Select
								isSearchable={false}
								options={[
									{ value: 'id', label: t("search_by_id") },
									{ value: 'city', label: t("search_by_city") },
									{ value: 'date', label: t("search_by_transport_date") },
								]}
								styles={{
									option: (provided, state) => ({
										...provided,
										fontFamily: 'Montserrat',
									}),
									control: (provided, state) => ({
										...provided,
										height: '3rem',
										minHeight: 'fit-content',
									}),
									valueContainer: (base) => ({
										...base,
										maxHeight: '3rem',
										fontSize: isSmallScreen ? '14px' : '16px',
									}),
								}}

								value={selectedOption}
								onChange={handleChange}
								menuPortalTarget={document.querySelector('body')}
							/>
						</div>
						{searchCriteria === 'id' ? (
							<input
								style={{
									padding: '0.4rem',
									borderRadius: 5,
									border: '1px solid #E4EAF0',
									height: '3rem',
									width: isSmallScreen ? '100%' : '20rem',
									fontFamily: 'Montserrat',
								}}
								value={searchQueryId}
								onChange={(e) => setSearchQueryId(e.target.value)}

							/>
						) : null}
						{searchCriteria === "city" ? (
							<div style={{ width: isSmallScreen ? '100%' : '20rem',}}>
								<AutocompleteAddress
									onPlaceSelect={(placeDetails) => {
									}}
									onValueChange={async (selectedValue) => {
										if (selectedValue) {
											setAdresseValue(selectedValue);
										}
									}}
									value={adresseValue}
									placeholder={t("enter_european_location")}

								/>
							</div>
						) : null}


						{searchCriteria === 'date' ? (
							<input
								style={{
									padding: '0.4rem',
									borderRadius: 5,
									border: '1px solid #E4EAF0',
									height: '3rem',
									width: isSmallScreen ? '100%' : '20rem',
									fontFamily: 'Montserrat',
								}}
								value={selectedDate}
								type="date"
								onChange={(e) => setSelectedDate(e.target.value)}
								placeholder={t("search")}
							/>
						) : null}
						<button
							onClick={handleSearch}
							style={{
								padding: '0.6rem 1rem',
								height: '3rem',
								background: '#C9D5F7',
								border: 'none',
								cursor: 'pointer',
								color: '#1C63C5',
								borderRadius: 7,
								marginLeft: isSmallScreen ? '0' : '1rem',
								width: isSmallScreen ? '100%' : '',
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
							}}
						>
							{t("search")}
						</button>
						<button
							onClick={resetData}
							style={{
								padding: '0.6rem 2rem',
								height: '3rem',
								background: '#C9D5F7',
								border: 'none',
								cursor: 'pointer',
								color: '#1C63C5',
								borderRadius: 7,
								marginRight: isSmallScreen ? '0' : '1rem',
								marginLeft: isSmallScreen ? '0' : '1rem',
								fontFamily: 'Montserrat',
								fontWeight: 'bold',
								width: isSmallScreen ? '100%' : ''
							}}
						>
							{t("clear")}
						</button>
					</div>
					{chargementEnCours ?
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								backgroundColor: 'white',
								marginTop: "10rem",
								marginLeft: "28rem"
							}}
						>
							<div className='customLoader'></div>
						</div>
						:
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								flexWrap: 'wrap',
								width: '100%',
								height: '100%',
								alignItems: 'flex-start',
								marginBottom: '2rem',
							}}
						>
							{commandes?.length === 0 ?
								<span
									style={{


										display: 'flex',
										textAlign: 'center',
										alignItems: 'center',
										justifyContent: 'center',
										paddingLeft: '300px'
									}}
								>
									{t("no_orders_msg")}
								</span>
								: commandes.map((commande) => {
									if (commande.type_commande === 'course-a-course') {
										return (
											<CourseACourseHorizontal
												key={commande._id}
												commande={commande}
												hideAttribuer
												hideTarif
												hideRecu
												hidecancel
												hidefacture
												hideStatus
												hideUpdate
												enableSaveStatus
												onClickDetails={() => {
													history.push(
														`/chauffeur/transports-details/${commande._id}`
													)
												}}
												onClickSignaler={() => {
													history.push(
														`/chauffeur/transports/${commande._id}/signaler`
													)
												}}
											/>
										)
									} else {
										return (
											<MiseADispoHorizontal
												key={commande._id}
												commande={commande}
												hideStatus
												onClickDetails={() => {
													setSelectedCommande(commande?._id)
													setModalIsOpenDetail(true)
												}}

											/>
										)
									}
								})}
						</div>
					}
				</div>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<UltimatePaginationBasic
						currentPage={page}
						totalPages={total}
						onChange={(newPage) => setPage(newPage)}
					/>
				</div>
			</div>
			<DetailCommandeModal
				isOpen={modalIsOpenDetail}
				onClose={() => setModalIsOpenDetail(false)}
				commandeId={selectedCommande}
			/>
		</LayoutChauffeur>
	)
}

export default HistoriqueChauffeur
